// Role-based gating for OTA actions.
//
// Mirrors the canonical RBAC sketch in OTA-Production-Beta-Plans/06-PROMOTION-INFRASTRUCTURE.md.
// v1 keeps it client-side for UI affordance; the server enforces the same rules
// once Phase B (promote/rollback/halt endpoints) lands.

import type { OtaAppId, OtaReleaseChannelId } from './types';

export type UserRole = 'super_admin' | 'admin' | 'tester_plus' | 'tester' | 'user';

export type OtaAction =
  | 'promote'
  | 'rollback'
  | 'halt'
  | 'resume'
  | 'widen'
  | 'pin'
  | 'swap-app-version'
  | 'manage-device-channels';

export interface PermissionContext {
  channel?: OtaReleaseChannelId;
  app?: OtaAppId;
}

export function canDo(role: UserRole, action: OtaAction, ctx: PermissionContext = {}): boolean {
  // Read-only roles.
  if (role === 'user' || role === 'tester') return false;
  if (role === 'tester_plus') {
    // Tester+ can promote into test channels only.
    return action === 'promote' && ctx.channel === 'beta';
  }
  // Launcher promotion to general release requires super_admin.
  if (ctx.app === 'launcher' && action === 'promote' && ctx.channel === 'general') {
    return role === 'super_admin';
  }
  // Swapping which app version is bundled in a release is super_admin-only.
  if (action === 'swap-app-version') {
    return role === 'super_admin';
  }
  if (action === 'manage-device-channels') {
    return role === 'super_admin';
  }
  return role === 'super_admin' || role === 'admin';
}
